import React from 'react';
import Link from 'gatsby-link';
import Helmet from 'react-helmet';
import BannerLanding from '../components/BannerLanding';
import Image from '../components/ImageShift';
//import searchEngine from '../assets/images/parts-de-marche-moteurs-recherche-france.png';
//import wp from '../assets/images/wordpress.jpg';
//import joomla from '../assets/images/Joomla.png';
//import ps from '../assets/images/prestashop-logo.png';
//import woo from '../assets/images/woocommerce.png';
//import vitrine from '../assets/images/site-vitrine.jpg';
//import reactlogo from '../assets/images/react-logo.png';
//import applelogo from '../assets/images/apple-gray-logo.png';
//import androidlogo from '../assets/images/android-logo.png';
//import dev from '../assets/images/web_programming.jpg';


const pageTitle = "Sites & Applis";
const pageContent = ["Besoin de visibilité en ligne pour votre activité ?", "Envie de vous lancer dans le e-commerce ?", "Une idée d’application à développer ?"];
//const pageContent = ["Vous voulez optimiser la visibilité en ligne de votre activité ?","Vous souhaitez vous lancer dans le e-commerce ?","Vous avez une idée d’application à développer ?"];
const icon = "desktop";

const Generic = (props) => (
	<div style={props.transition && props.transition.style}>
		<Helmet>
			<title>Web 2 Alpes - Création de sites Internet et applications</title>
			<meta name="description" content="Creation de sites internet et d'applications mobiles (Android, IOS)" />
			<meta name="language" content="fr-FR" />
            <meta http-equiv="content-type" content="text/html; charset=UTF-8" />
            <meta http-equiv="content-language" content="fr-FR" />
		</Helmet>
		<BannerLanding icon={icon} title={pageTitle} content={pageContent} particles="cms" />
		<div id="main" className="alt">
			<section className="tiles">
				<article className="full-medium">
					<div className="inner">
						<header className="major">
							<h2>Votre site Internet</h2>
						</header>
						<p className="preul">De plus en plus d’artisans, commerces, associations et sociétés de services / loisirs créent leur <strong>site vitrine</strong> ou <strong>e-commerce</strong>. Je vous aide à créer le vôtre :</p>
						<ul className="snow">
							<li><strong>conception</strong> (graphisme, design, choix des fonctionnalités...),</li>
							<li><strong>réalisation</strong> (développement ou intégration),</li>
							<li><strong>configuration</strong> (optimisation, référencement, sécurité...),</li>
							<li><strong>mise en ligne</strong> (réservation du nom de domaine, choix de l’hébergeur...),</li>
							<li><strong>gestion</strong> (je le modifie selon vos besoins ou vous forme à le faire seul).</li>
						</ul>
						<p className="bordertop">Pour discuter sans engagement de votre projet <strong><Link to="#contact">contactez moi !</Link></strong></p>
					</div>
				</article>
				<article className="full-medium">
					<div className="inner">
						<header className="major">
							<h2>Un site personnalise</h2>
						</header>
						<p className="preul">Carte de visite, vitrine ou e-commerce, les <strong>CMS  (système de gestion de contenu)</strong> vous aident à créer un site unique à partir de milliers : </p>
						<ul className="snow">
							<li><strong>d’extensions</strong> pour intégrer des fonctionnalités (portfolio, blog, réservation, paiement sécurisé...)</li>
							<li><strong>de thèmes</strong> pour personnaliser le graphisme.</li>
						</ul>
						<p>Et pour un projet encore plus spécifique, je développe <strong>votre application entièrement sur mesure</strong>.</p>
					</div>
				</article>
				<article className="full-medium">
					<div className="inner">
						<header className="major">
							<h2>Un site economique</h2>
						</header>
						<p>Les CMS permettent <strong>un gain de temps et d’argent considérable</strong> en offrant aux professionnels de multiples solutions à leurs problématiques variées.</p>
						<p>Parmi toutes les applications gratuites du marché, je vous aide à <strong>choisir la plus pertinente</strong> pour votre projet et à <strong>exploiter au mieux son potentiel</strong>.</p>
						<p className="bordertop">Les CMS les plus utilisés : <a href="https://fr.wordpress.org/" target="_blank"><strong>Wordpress</strong></a>, <a href="https://fr.wordpress.org/plugins/woocommerce/" target="_blank"><strong>Woocommerce</strong></a>, <a href="https://addons.prestashop.com/fr/3-themes-prestashop?utm_source=prestashop.com&utm_medium=main-menu&utm_campaign=internal-linking&utm_content=theme" target="_blank"><strong>Prestashop</strong></a>, <a href="https://www.drupal.org/" target="_blank"><strong>Drupal</strong></a> et <a href="https://magento.com/schedule-a-demo" target="_blank"><strong>Magento</strong></a>.</p>
					</div>
				</article>
				<article className="full-medium">
					<div className="inner">
						<header className="major">
							<h2>Mes garanties</h2>
						</header>
						<ul className="snow">
							<li><strong>Une qualité professionnelle</strong> aux derniers standards du web</li>
							<li><strong>Un site optimisé et sécurisé</strong></li>
							<li>La possibilité de consulter ma <strong><a href="http://www.madecommunication.fr" target="_blank">collaboratrice graphiste</a></strong> (logo, design...)</li>
							<li><strong>Un design responsive</strong> (votre site s’adapte à tous types d’écran)</li>
							<li><strong>Un référencement naturel</strong> optimisé sur Google (vos clients vous trouvent)</li>
							<li><strong>Un accompagnement</strong> à tous les niveaux (en fonction de vos besoins)</li>
							<li><strong>Une documentation</strong> avec toutes les données techniques (pour faire évoluer votre site avec ou sans mon aide)</li>
						</ul>
						<div className="bordertop">
						<nav>
                            <Link to="#contact" className="button small">Devis gratuit <i className="icon fa-euro"></i></Link>
                            <Link to="/pack-site-vitrine/" className="button small">Pack vitrine <i className="icon fa-wordpress"></i></Link>
                            <Link to="/pack-e-commerce/" className="button small">Pack e-commerce <i className="icon fa-shopping-cart"></i></Link>
                        </nav>
						</div>
					</div>
				</article>
			</section>
		</div>
	</div>
)

export default Generic



// WEBPACK FOOTER //
// ./src/pages/creation-sites-internet-et-applications.js